/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { MeControllerFindUserDetailsQueryResponse, MeControllerFindUserDetails400, MeControllerFindUserDetails401, MeControllerFindUserDetails404, MeControllerFindUserDetails409, MeControllerFindUserDetails500 } from "../types/MeControllerFindUserDetails.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getMeControllerFindUserDetailsUrl() {
  const res = { method: 'GET', url: `/api/me` as const }
  return res
}

/**
 * @description Retrieves the details of the currently authenticated user.
 * @summary Get user details
 * {@link /api/me}
 */
export async function meControllerFindUserDetails(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MeControllerFindUserDetailsQueryResponse, ResponseErrorConfig<MeControllerFindUserDetails400 | MeControllerFindUserDetails401 | MeControllerFindUserDetails404 | MeControllerFindUserDetails409 | MeControllerFindUserDetails500>, unknown>({ method : "GET", url : getMeControllerFindUserDetailsUrl().url.toString(), ... requestConfig })
  return res.data
}